import * as React from 'react';
import { 
  Box,
  DialogContent,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  InputLabel,
  Select,
  MenuItem,
  Grid
} from '@mui/material';

import { useSelector, useDispatch } from 'react-redux'
import { getUser } from '../slices/auth';
import { createSlide, updateSlide } from '../slices/presentation';
import { CDialog, CDialogTitle, CDialogActions, CButton, CTextField } from '../components/common/Modal';

export default function SlideModal(props) {
  const dbs = useSelector(state => state.auth.user.db);

  const {open, defaultTitle, defaultPrompt, defaultVisualization, defaultDatabase, defaultComment, handleClose, pId, index, updateMode} = props;
  const [loading, setLoading] = React.useState(false);

  const [title, setTitle] = React.useState(defaultTitle);
  const [prompt, setPrompt] = React.useState(defaultPrompt);
  const [visualization, setVisualization] = React.useState(defaultVisualization);
  const [database, setDatabase] = React.useState(defaultDatabase);
  const [comment, setComment] = React.useState(defaultComment);
  const dispatch = useDispatch();

  React.useEffect(() => {
    setTitle(defaultTitle);
    setPrompt(defaultPrompt);
    setVisualization(defaultVisualization);
    setDatabase(defaultDatabase);
    setComment(defaultComment);

    if(!dbs) {
      dispatch(getUser())
    }
  }, [defaultTitle, defaultPrompt, defaultVisualization, defaultDatabase, defaultComment, dbs, dispatch]);

  const handleSend = (e) => {
    if(prompt === "") {
      window.alert("Please input the prompt.");
      return;
    }

    setLoading(true);
    if(updateMode) {
      dispatch(updateSlide({
        presentation: pId,
        index,
        title,
        source: database,
        prompt,
        comment,
        visualization
      })).then(() => {
        setLoading(false);
        handleClose(); // Call handleClose after the setVisualization action has finished
      })
      .catch(err => {
        setLoading(false);
      })  
    }
    else {
      dispatch(createSlide({
        presentation: pId,
        title,
        source: database,
        prompt,
        comment,
        visualization
      })).then(() => {
        setLoading(false);
        handleClose(); // Call handleClose after the setVisualization action has finished
      })
      .catch(err => {
        setLoading(false);
      })  
    }
  }

  return (
    <>
      <CDialog
        open={open}
        onClose={handleClose}
        maxWidth={"md"}
        fullWidth
      >
        <CDialogTitle>New Slide</CDialogTitle>
        <DialogContent>
          <CTextField
            id={`title`} 
            label={`Title`}
            size="small"
            rows={3}
            variant="outlined"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            sx={{
              marginTop: '1rem'
            }}
            fullWidth
          />
          <FormControl 
            sx={{
              marginTop: '1rem'
            }} 
            size='small'
            fullWidth
          >
            <InputLabel id="demo-simple-select-label">Data Source</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={database}
              margin='dense'
              label="Data Source"
              onChange={(e) => setDatabase(e.target.value)}
              fullWidth={true}
              variant='outlined'
              >
                {
                  dbs && dbs.length>0 && dbs.map(item=> (<MenuItem key={item.name} value={item.name}>{item.name}</MenuItem>))
                }
            </Select>
          </FormControl>
          <CTextField
            id={`prompt`} 
            label={`Prompt`}
            size="small"
            multiline
            rows={3}
            variant="outlined"
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            sx={{
              marginTop: '1rem',
            }}
            fullWidth
          />
          <Grid spacing={2} container>
            <Grid xs={6} item>
              <FormControl 
                sx={{
                  marginTop: '1rem'
                }} 
                size='small'
                fullWidth
              >
                <InputLabel id="demo-simple-select-label">Visualization</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={visualization}
                  margin='dense'
                  label="Data Source"
                  onChange={(e) => setVisualization(e.target.value)}
                  fullWidth={true}
                  variant='outlined'
                  >
                    <MenuItem value={'chart'}>Visualization</MenuItem>
                    <MenuItem value={'table'}>Data Table</MenuItem>
                    <MenuItem value={'ultra'}>Visualization & Table</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid xs={6} item>
              <FormControlLabel control={<Checkbox checked={comment} onChange={(e) => setComment(e.target.checked)} />} label="Comment" />
            </Grid>          
          </Grid>
          {loading && (
            <Box className="absolute w-full h-full" sx={{top: 0, left: 0}}>
              <Box className="relative w-full h-full">
                <Box className="w-full h-full flex justify-center align-center">
                  <CircularProgress sx={{opacity: 0.7}} />
                </Box>
              </Box>
            </Box>)
          }  
        </DialogContent>
        <CDialogActions>
          <CButton onClick={handleClose}>Cancel</CButton>
          <CButton onClick={handleSend} disabled={loading}>Ok</CButton>
        </CDialogActions>
      </CDialog>
    </>
  )
}